import React, { useState } from 'react';
import axios from 'axios';

function AppointmentForm() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    date: '',
    service: '',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await axios.post('https://ricgop.online/api/appointmentForm.php', formData);
      alert('Appointment booked successfully!');
      setFormData({
        name: '',
        email: '',
        phone: '',
        date: '',
        service: '',
        subject: '',
        message: ''
      });
    } catch (error) {
      alert('Error booking appointment.');
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <label>Full Name:</label>
      <input type="text" name="name" value={formData.name} onChange={handleChange} required />

      <label>Email:</label>
      <input type="email" name="email" value={formData.email} onChange={handleChange} required />

      <label>Phone Number:</label>
      <input type="tel" name="phone" value={formData.phone} onChange={handleChange} required />

      <label>Preferred Date:</label>
      <input type="date" name="date" value={formData.date} onChange={handleChange} required />

      <label>Service:</label>
      <select name="service" value={formData.service} onChange={handleChange} required>
        <option value="">Select a Service</option>
        <option value="primary-care">Primary Care</option>
        <option value="speciality-care">Speciality Care</option>
        <option value="emergency-care">Emergency Care</option>
        <option value="surgical-services">Surgical Services</option>
        <option value="mental-health">Mental Health Services</option>
      </select>

      <label>Subject:</label>
      <input type="text" name="subject" value={formData.subject} onChange={handleChange} />

      <label>Message:</label>
      <textarea name="message" value={formData.message} onChange={handleChange}></textarea>

      <button type="submit">Book Appointment</button><br /><br />
      <a href="/home-5">Back To Home</a>
    </form>
  );
}

export default AppointmentForm;
